import { IAuthorizedMedia, IMedia } from "../Search/Types";

export enum IUserActionTypes {
    LOGIN = '@@user/LOGIN',
    LOGOUT = '@@user/LOGOUT',
    LOGIN_SUCCESS = '@@user/LOGIN_SUCCESS',
    LOGIN_ERROR = '@@user/LOGIN_ERROR',
    
    CREATE_SCHEMA = '@@user/CREATE_SCHEMA',

    SAVE_EXTERNAL_TOKEN = '@@user/SAVE_EXTERNAL_TOKEN',
    VERIFY_EXTERNAL_TOKEN = '@@user/VERIFY_EXTERNAL_TOKEN',
    VERIFY_EXTERNAL_TOKEN_ERROR = '@@user/VERIFY_EXTERNAL_TOKEN_ERROR',
    VERIFY_EXTERNAL_TOKEN_SUCCESS = '@@user/VERIFY_EXTERNAL_TOKEN_SUCCESS',

    GET_TOKEN_PLAYER = '@@user/GET_TOKEN_PLAYER',
    GET_TOKEN_PLAYER_SUCCESS = '@@user/GET_TOKEN_PLAYER_SUCCESS',

    GET_AUTHORIZED_MEDIAS = '@@user/GET_AUTHORIZED_MEDIAS',
    GET_AUTHORIZED_MEDIAS_SUCCESS = '@@user/GET_AUTHORIZED_MEDIAS_SUCCESS',
    GET_AUTHORIZED_MEDIAS_ERROR = '@@user/GET_AUTHORIZED_MEDIAS_ERROR',

}
export const CPermissionInitial:IPermission = {
    show_total: false
}
export interface IPermission {
    show_total: boolean
}

export interface IResults {
    readonly expires: number;
    readonly token: string;
    readonly user: any;
    readonly media_list: IAuthorizedMedia[]
    readonly have_right_show_total: boolean;
}

export interface IUserState {
    readonly username: string;
    readonly token: string;
    readonly expires: Date;
    readonly permissions: IPermission;
    readonly errorMessage:any
    readonly tokenPlayer: string;
    readonly medias: IMedia[];
    readonly allMediasID: number[];
    readonly allMediasSTR: string[];
    readonly user_id: number; 
    readonly max_advancement_date: Date | null;
    readonly tokenExternal: string | null;
}
